import RequireAuth from "./RequireAuth";

export default RequireAuth;
